if (!customElements.get('mini-mint-reviews')) {
  customElements.define('mini-mint-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const track = this.querySelector('.mini-mint-reviews__track');
      const source = this.querySelector('[data-reviews-source]');
      const previous = this.querySelector('[data-reviews-prev]');
      const next = this.querySelector('[data-reviews-next]');
      if (!track || !source || !previous || !next) return;
      track.replaceChildren();
      const text = (item, selector) => item.querySelector(selector)?.textContent.trim() || '';
      const seenReviews = new Set();
      for (const item of source.content.querySelectorAll('.jdgm-carousel-item')) {
        const body = text(item, '.jdgm-carousel-item__review-body');
        if (!body) continue;
        const reviewKey = body.normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
        if (seenReviews.has(reviewKey)) continue;
        seenReviews.add(reviewKey);
        const card = document.createElement('li');
        card.className = 'mini-mint-reviews__card';
        const append = (tag, className, value) => {
          const el = document.createElement(tag);
          el.className = className;
          el.textContent = value;
          card.append(el);
          return el;
        };
        const label = item.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label');
        const score = Number(label?.match(/^[0-5](?:\.\d+)?/)?.[0]);
        if (label && Number.isFinite(score) && score <= 5) {
          const rating = append('div', 'mini-mint-reviews__rating', '★'.repeat(Math.round(score)) + '☆'.repeat(5 - Math.round(score)));
          rating.setAttribute('role', 'img');
          rating.setAttribute('aria-label', label);
        }
        const title = text(item, '.jdgm-carousel-item__review-title');
        if (title) append('p', 'mini-mint-reviews__source', title);
        const quote = append('blockquote', 'mini-mint-reviews__quote', body);
        quote.tabIndex = 0;
        quote.setAttribute('aria-label', this.dataset.label);
        const author = text(item, '.jdgm-carousel-item__reviewer-name');
        if (author) append('p', 'mini-mint-reviews__author', author);
        const product = item.querySelector('.jdgm-carousel-item__product-image')?.getAttribute('alt');
        if (product) append('p', 'mini-mint-reviews__product', product);
        track.append(card);
      }
      this.hidden = !track.children.length;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const distance = () => track.firstElementChild?.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap) || track.clientWidth;
      const move = direction => track.scrollBy({ left: direction * distance() * (rtl ? -1 : 1), behavior: 'instant' });
      const sync = () => {
        const position = Math.abs(track.scrollLeft);
        previous.disabled = position <= 2;
        next.disabled = position >= track.scrollWidth - track.clientWidth - 2;
      };
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', sync, { passive: true, signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, { signal });
      this.resizeObserver = new ResizeObserver(sync);
      this.resizeObserver.observe(track);
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  });
}
